import { collectionConstants } from '../Constants';

export function collection(state = {}, action) {
    switch (action.type) {
        case collectionConstants.GET_COLLECTIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case collectionConstants.GET_COLLECTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.collections
            };
        case collectionConstants.GET_COLLECTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case collectionConstants.POST_UPLOAD_COLLECTIONS_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case collectionConstants.POST_UPLOAD_COLLECTIONS_SUCCESS:
            return {
                ...state,
                postloading: false,
                successItems: action.uploadCollection
            };
        case collectionConstants.POST_UPLOAD_COLLECTIONS_FAILURE:
            return {
                ...state,
                postloading: false,
                posterror: action.error
            };
        case collectionConstants.POST_AUTH_REQUEST:
            return {
                ...state,
                postauthloading: true
            };
        case collectionConstants.POST_AUTH_SUCCESS:
            return {
                ...state,
                postauthloading: false,
                authitems: action.auth
            };
        case collectionConstants.POST_AUTH_FAILURE:
            return {
                ...state,
                postauthloading: false,
                postautherror: 'message' in action.error ? action.error.message : action.error
            };
        default:
            return state
    }
}